
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitoashtavinayakcabservice() {



    const cardData =
    {
        keyword: ' Mumbai to Ashtavinayak Cab Service',
        heading: 'Deva Cabs: Mumbai to Ashtavinayak Cab Service    ',
        headingDescription: 'Deva Cabs offers dedicated and comfortable cab services for the Mumbai to Ashtavinayak Yatra, ideal for spiritual seekers, family groups, and senior citizens. Covering all eight sacred Ganpati temples across Maharashtra, our Ashtavinayak tour package ensures a smooth, safe, and spiritually fulfilling journey. Travel in well-maintained Sedans, SUVs, or Innova Crysta with experienced drivers who know the route and temple timings. With fixed pricing, custom itinerary options, and 24/7 availability, Deva Cabs makes your Ashtavinayak Darshan from Mumbai truly divine and hassle-free.',

        top: 'Top Places to Visit in Ashtavinayak with Deva Cabs',

"topPlaces": [
  {
    "title": "Mayureshwar Temple (Morgaon)",
    "location": "Morgaon, Pune District, Maharashtra",
    "description": "Mayureshwar Temple in Morgaon is the first and most important Ashtavinayak temple, considered the 'Adhya Peeth'. It is believed to be where Lord Ganesha took the form of Mayureshwar riding a peacock. The temple is located on the banks of the Karha River and showcases beautiful black stone architecture with a central idol of Ganesha flanked by Siddhi and Buddhi."
  },
  {
    "title": "Siddhivinayak Temple (Siddhatek)",
    "location": "Siddhatek, Ahmednagar District, Maharashtra",
    "description": "Siddhivinayak Temple in Siddhatek is located on a hillock along the Bhima River and is known for fulfilling wishes. It is the only Ashtavinayak temple where Lord Ganesha’s idol has a trunk turned to the right, which is considered especially powerful. Devotees often perform pradakshina (circumambulation) of the hill while chanting mantras."
  },
  {
    "title": "Ballaleshwar Temple (Pali)",
    "location": "Pali, Raigad District, Maharashtra",
    "description": "Ballaleshwar Temple in Pali is the only Ashtavinayak shrine where Lord Ganesha is known by the name of his devotee, Ballal. The temple is unique for its east-facing idol and architecture designed to allow sun rays to fall on the deity during specific times of the year. It’s surrounded by scenic hills and greenery."
  },
  {
    "title": "Varad Vinayak Temple (Mahad)",
    "location": "Mahad, Raigad District, Maharashtra",
    "description": "Varad Vinayak Temple in Mahad is believed to grant boons and fulfill wishes. The temple is simple and peaceful, located amidst forests and a sacred pond. What makes it unique is that devotees can enter the inner sanctum and directly touch the idol of Lord Ganesha while offering prayers."
  },
  {
    "title": "Chintamani Temple (Theur)",
    "location": "Theur, Pune District, Maharashtra",
    "description": "Chintamani Temple in Theur is associated with the legend of Lord Ganesha retrieving the wish-fulfilling gem for sage Kapila. Located near the Mula-Mutha river confluence, the temple is known for its tranquil environment and beautiful wooden architecture. It was also frequently visited by the Peshwas."
  },
  {
    "title": "Girijatmaj Temple (Lenyadri)",
    "location": "Lenyadri, Pune District, Maharashtra",
    "description": "Girijatmaj Temple in Lenyadri is carved into a single rock on a hill and is the only Ashtavinayak temple located in a cave. It is believed that Goddess Parvati performed penance here and Ganesha was born as Girijatmaj. Reaching the temple requires climbing 300+ steps, but the panoramic view and rock-cut beauty make it worthwhile."
  },
  {
    "title": "Vighnahar Temple (Ozar)",
    "location": "Ozar, Pune District, Maharashtra",
    "description": "Vighnahar Temple in Ozar is associated with Lord Ganesha as the remover of obstacles (Vighnasura). It features a gold-plated dome and intricate stone carvings. The temple is known for its cleanliness, peaceful riverfront location, and the belief that prayers here remove all hurdles from one’s life."
  },
  {
    "title": "Mahaganapati Temple (Ranjangaon)",
    "location": "Ranjangaon, Pune District, Maharashtra",
    "description": "Mahaganapati Temple in Ranjangaon is where Lord Shiva is believed to have worshipped Ganesha before battling Tripurasura. The temple features a powerful and majestic idol of Mahaganapati seated on a lotus. Its sanctum sanctorum is built so that light never falls directly on the idol, maintaining its aura of mystery and divinity."
  }
],



"services": [
  {
    "name": "Mumbai to Ashtavinayak Cab",
    "description": "Embark on a sacred journey to all eight revered Ashtavinayak Ganpati temples across Maharashtra with Deva Cabs’ Mumbai to Ashtavinayak cab service. Covering iconic shrines such as Morgaon, Siddhatek, Pali, and others, our comfortable and reliable cabs are perfect for one-day or multi-day trips. With experienced drivers familiar with the routes and temple locations, you can focus on your devotion while we handle the road."
  },
  {
    "name": "Ashtavinayak Darshan taxi from Mumbai",
    "description": "Book a dedicated taxi from Mumbai for your Ashtavinayak Darshan. Our service includes structured temple routes, knowledgeable drivers, and full-day assistance across the eight temples. Whether traveling with family or in a small group, our taxis ensure a peaceful and well-coordinated pilgrimage experience with stopovers for meals and breaks."
  },
  {
    "name": "One-day Ashtavinayak trip cab Mumbai",
    "description": "Planning a tight-schedule pilgrimage? Choose Deva Cabs’ one-day Ashtavinayak trip from Mumbai. We offer early morning pickups and optimized routes to cover as many temples as possible within a single day. Our cabs are equipped with AC, push-back seats, and ample luggage space — ideal for devout travelers who prefer quick and efficient spiritual visits."
  },
  {
    "name": "Round trip cab Mumbai to Ashtavinayak",
    "description": "Deva Cabs offers customizable round-trip packages for Ashtavinayak Darshan starting from Mumbai. Keep your vehicle and driver with you throughout the trip, allowing flexibility for overnight stays, detours, or longer visits to certain temples. It’s the best option for families and groups who prefer a relaxed and uninterrupted pilgrimage experience."
  },
  {
    "name": "AC cab Ashtavinayak from Mumbai",
    "description": "Enjoy your Ashtavinayak pilgrimage in cool comfort with our fully air-conditioned cabs. Whether you're traveling in summer or prefer a dust-free ride, our AC cabs make the long road hours soothing and fatigue-free. Choose from sedans, SUVs, or tempo travellers based on your group size."
  },
  {
    "name": "Chauffeur cab for Ashtavinayak Darshan",
    "description": "Our chauffeur-driven cab service for Ashtavinayak Darshan ensures a smooth and spiritual travel experience. Our trained drivers are courteous, punctual, and knowledgeable about the temple sequence and locations, helping you maintain your spiritual rhythm throughout the journey without worrying about routes or timings."
  },
  {
    "name": "Online booking cab Mumbai to Ashtavinayak",
    "description": "Book your cab online from Mumbai to Ashtavinayak temples in just a few clicks. With Deva Cabs’ seamless digital platform, you get instant confirmation, upfront pricing, and vehicle options suited to your schedule and budget. Get real-time tracking, support, and peace of mind from start to finish."
  },
  {
    "name": "Luxury cab Ashtavinayak trip from Mumbai",
    "description": "Opt for a premium travel experience on your spiritual journey with our luxury cabs. Deva Cabs offers Innova Crysta, Hyundai Tucson, and other high-end vehicles for the Ashtavinayak route. Enjoy plush seating, extra space, and a smooth ride — perfect for family heads, spiritual leaders, or those who seek added comfort on long pilgrimages."
  },
  {
    "name": "Family cab Mumbai to Ashtavinayak temples",
    "description": "Deva Cabs understands the needs of family pilgrimages and offers safe, clean, and comfortable cabs for the Ashtavinayak Yatra. Whether you’re traveling with elders, kids, or a large family group, we provide suitable vehicles with extra space and supportive drivers who assist with temple timings and comfort breaks."
  },
  {
    "name": "Pilgrimage cab hire Mumbai to Ashtavinayak",
    "description": "Our pilgrimage cab hire for Ashtavinayak Darshan is designed for spiritual travelers who prioritize reliability, comfort, and respectful service. From vehicle hygiene to driver etiquette and route planning, every element is managed with devotion in mind. Best suited for devotees, senior citizens, and spiritual groups."
  },
  {
    "name": "Affordable taxi Ashtavinayak from Mumbai",
    "description": "Get budget-friendly taxi options for your Ashtavinayak journey from Mumbai without compromising on safety or service. Deva Cabs offers transparent rates, no hidden fees, and flexible payment options. Great for small families, solo pilgrims, and group travelers looking for value-based travel solutions."
  },
  {
    "name": "Premium Ashtavinayak cab Mumbai",
    "description": "Experience a premium level of service on your spiritual journey with Deva Cabs’ premium Ashtavinayak cab offerings. From executive sedans to luxury SUVs, we ensure a top-tier travel experience, complete with professionally dressed chauffeurs, water bottles, clean interiors, and full itinerary support."
  }
],
"tableData": [
  ["Mumbai to Ashtavinayak Cab", "-Ashtavinayak Darshan taxi from Mumbai"],
  ["One-day Ashtavinayak trip cab Mumbai", "-Round trip cab Mumbai to Ashtavinayak"],
  ["AC cab Ashtavinayak from Mumbai", "-Chauffeur cab for Ashtavinayak Darshan"],
  ["Online booking cab Mumbai to Ashtavinayak", "-Luxury cab Ashtavinayak trip from Mumbai"],
  ["Family cab Mumbai to Ashtavinayak temples", "-Pilgrimage cab hire Mumbai to Ashtavinayak"],
  ["Affordable taxi Ashtavinayak from Mumbai", "-Premium Ashtavinayak cab Mumbai"]
],

whychoose: [
  {
    "WhyChooseheading": "Convenient Mumbai to Ashtavinayak Darshan Cab Service",
    "WhyChoosedescription": "Embark on a spiritual journey from Mumbai to all eight revered Ashtavinayak Ganpati temples with our expertly planned cab service. We cover the full pilgrimage circuit—starting from Mumbai and visiting each temple in a comfortable, time-efficient manner. With us, you experience complete peace of mind, knowing that every detail—from route optimization to temple timings—is handled with care and devotion."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles for Pilgrimage Travel",
    "WhyChoosedescription": "Traveling across Maharashtra’s countryside to visit the eight sacred Ganpati temples can take over 900 kilometers. That’s why we provide well-maintained, air-conditioned, and spacious vehicles that are ideal for long-duration travel. With cushioned seating, ample luggage space, and smooth suspension, our cabs ensure a relaxed and peaceful journey for senior citizens, families, and groups of all sizes."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Temple Route Expertise",
    "WhyChoosedescription": "Our drivers are trained for religious tours and are well-versed with the Ashtavinayak route, temple timings, darshan procedures, and the best roads to avoid delays. They’re polite, punctual, and helpful—guiding you throughout the darshan journey while ensuring your safety and comfort. Many of them have years of experience conducting Ashtavinayak tours and understand the spiritual significance of every stop."
  },
  {
    "WhyChooseheading": "Customizable Itinerary – One Day, Two Day, or Extended Plans",
    "WhyChoosedescription": "We offer flexible travel packages depending on your time and pace preferences. Choose from a 1-day express darshan, a relaxed 2-day itinerary with overnight stay, or a custom multi-day spiritual retreat. Whether you're visiting all 8 temples in one go or splitting the journey, our team customizes the route to match your needs and ensures complete comfort throughout."
  },
  {
    "WhyChooseheading": "Transparent Pricing Without Hidden Charges",
    "WhyChoosedescription": "With our service, you get clear, upfront pricing that includes tolls, taxes, fuel, and driver expenses—no last-minute surprises. We provide detailed cost breakdowns before your trip begins, helping you budget accurately for a meaningful and affordable pilgrimage experience."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Pilgrimage Scheduling",
    "WhyChoosedescription": "Spiritual journeys don’t always follow a fixed clock—that’s why we offer round-the-clock availability. Whether you prefer to start your Ashtavinayak darshan before dawn or on a weekend evening, our cab service is ready when you are. We accommodate early departures, temple-specific timings, and even extended detours if needed."
  },
  {
    "WhyChooseheading": "Clean, Sanitized, and Safe Vehicles for Devotees",
    "WhyChoosedescription": "Your well-being is our top concern. All vehicles are sanitized before every trip and undergo regular maintenance checks. We equip every cab with safety features like seat belts, GPS tracking, and emergency kits to ensure a secure, worry-free ride throughout the sacred Ashtavinayak route."
  },
  {
    "WhyChooseheading": "Complete Spiritual Experience with Hassle-Free Travel",
    "WhyChoosedescription": "Focus entirely on your darshan and spiritual intentions—leave the logistics to us. We manage all aspects of the road trip including route mapping, fuel stops, rest breaks, and temple scheduling. From Mumbai to Moreshwar and ending at Mahad or Ranjangaon, your Ashtavinayak journey will be smooth, organized, and truly divine."
  }
]









    }








const faqData = [
  {
    question: "Does Deva Cabs offer Mumbai to Ashtavinayak cab service?",
    answer: "Yes, Deva Cabs provides dedicated cab services for the complete Ashtavinayak Yatra from Mumbai covering all eight Ganpati temples in Maharashtra."
  },
  {
    question: "How long does the Ashtavinayak Yatra take by cab from Mumbai?",
    answer: "The entire journey usually takes 2 to 3 days depending on your itinerary and stops at each temple."
  },
  {
    question: "Can I customize my Ashtavinayak route and schedule?",
    answer: "Absolutely. We offer customizable packages allowing you to choose your preferred travel dates, duration, and temple order."
  },
  {
    question: "What vehicle options are available for the Ashtavinayak trip?",
    answer: "You can choose from sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers based on your group size and comfort preferences."
  },
  {
    question: "Is the cab service available for both one-way and round-trip Ashtavinayak tours?",
    answer: "Yes, we offer flexible one-way and round-trip options depending on your travel plan."
  },
  {
    question: "Are tolls, driver allowance, and parking charges included in the package?",
    answer: "These charges are usually extra and will be shared with full transparency during booking."
  },
  {
    question: "Are your drivers familiar with the Ashtavinayak temple route?",
    answer: "Yes, our drivers are experienced and well-versed with the Ashtavinayak route and temple timings."
  },
  {
    question: "Can I book a cab for just a few selected temples instead of all eight?",
    answer: "Yes, you can book a partial Ashtavinayak Yatra based on your spiritual or travel preference."
  },
  {
    question: "Is the trip safe and suitable for senior citizens or families?",
    answer: "Yes, our cabs are clean, comfortable, and safe — perfect for senior citizens, families, and large groups."
  },
  {
    question: "Why book the Ashtavinayak cab service with Deva Cabs?",
    answer: "Deva Cabs offers professional drivers, clean and spacious vehicles, flexible itineraries, and trusted service for a peaceful pilgrimage experience."
  }
];

const testimonialData = [
  {
    id: 45,
    name: 'Mr. Rajendra Patil',
    role: 'Devotee',
    review: 'We booked Deva Cabs for our family Ashtavinayak Yatra from Mumbai. The driver was very cooperative and knew all the temple routes well. Excellent service!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 46,
    name: 'Ms. Bhavana Deshmukh',
    role: 'Spiritual Traveler',
    review: 'Our 3-day Ashtavinayak trip with Deva Cabs was smooth and comfortable. Every detail was well taken care of. Highly recommended!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];









































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ashtavinayak Cab Service",
  "image": "https://devacab.com/assets/images/mumbai-to-ashtavinayak-cab.jpg", // Replace with actual image URL if different
  "description": "Book Mumbai to Ashtavinayak cab service with Deva Cabs for a smooth and spiritual journey covering all eight Ganpati temples in Maharashtra. Clean cars, professional drivers, and customized travel plans available.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3980"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6499",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-ashtavinayak-cab-service"
  }
};




    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Ashtavinayak Cab Service | Pilgrimage Tour Taxi - Deva Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Ashtavinayak cab service with Deva Cabs. Visit all 8 revered Ganpati temples comfortably. Clean cars, courteous drivers, and flexible trip plans. Hatchback, sedan, SUV, and tempo traveller options available." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Ashtavinayak Cab, Ashtavinayak Tour Taxi from Mumbai, Mumbai to Ashtavinayak Yatra Cab, Ashtavinayak Darshan from Mumbai, Mumbai to Ashtavinayak Car Rental, Ashtavinayak Cab Service Mumbai, One Day Ashtavinayak Cab, Ashtavinayak Cab with Driver, Tempo Traveller for Ashtavinayak from Mumbai, SUV for Ashtavinayak Darshan, Deva Cabs Mumbai to Ashtavinayak, Outstation Cab for Ashtavinayak Tour" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/31.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitoashtavinayakcabservice;